<template>
  <div>
    <template v-if="(parentFilter.tahun && parentFilter.kolok)">
      <b-overlay :show="isLoadDetail" variant="light" opacity="0.85" blur="2px" rounded="sm">
        <div class="card mb-1">
          <div class="card-header d-block border-bottom">
            <div class="text-center">
              <h4 class="font-weight-bolder text-uppercase text-primary">TIM INVENTARISASI PERALATAN DAN
                MESIN
                <br /> PADA {{ headerSkTim }}
                <br /> Tahun {{ parentFilter.tahun }}
              </h4>
            </div>
          </div>
          <div class="card-body pt-1">
            <div class="row py-1 px-0">
              <div class="col-12">
                <div class="d-flex flex-row justify-content-between overflow-auto">
                  <div class="mr-2" style="width: max-content;">
                    <div style="margin-bottom: 5px;">
                      <span class="font-weight-bolder text-uppercase">Nama PD/UKPD/UPB</span>
                    </div>
                    <div>
                      <span class="font-size-lg">{{ formDatas.nalok || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="!isFinal">
              <div
                v-if="['disetujui-ka'].includes(formDatas.status_hasil_akhir) && $can('Update', 'b-sk-tim')"
                class="row py-1 px-0 mx-0 d-flex justify-content-between">
                <div>
                  <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
                    @click="changeStateEvent('update')">
                    <feather-icon icon="EditIcon" class="mr-50" />
                    <span class="align-middle">Update Tim Inventarisasi</span>
                  </b-button>
                </div>
              </div>
            </div>
            <hr />
            <template v-for="(item, i) in formDatas.data_struktural" :keys="i">
              <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded">
                <div class="row">
                  <div class="col-12">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h5 class="font-weight-bold text-uppercase">
                          <span v-if="item.ref_jabatan_ba_tim_kode == 'ketua'">Ketua
                            ({{ lebelField('ketua') }})</span>
                          <span v-else-if="item.ref_jabatan_ba_tim_kode == 'wakil'">Wakil Ketua
                            (Pejabat
                            Eselon
                            II/III)</span>
                          <span v-else-if="item.ref_jabatan_ba_tim_kode == 'sekretaris'">Sekretaris
                            ({{ lebelField('sekretaris') }})</span>
                          <span v-else-if="item.ref_jabatan_ba_tim_kode == 'sekretariat'">Sekretariat
                            ({{ lebelField('sekretariat') }})</span>
                          <span v-else>{{ item.ref_jabatan_ba_tim_kode }}</span>
                          <span v-if="item.is_plt == 'iya'" class="text-warning ml-50">(PLT)</span>
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NRK</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nrk || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NAMA</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nama || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NIP</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nip || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <hr class="my-2" />
            <div class="row mb-1">
              <div class="col-12">
                <div>
                  <h5 class="font-weight-bold text-uppercase text-muted">Daftar Anggota ({{
                    lebelField('anggota') }})
                  </h5>
                </div>
              </div>
            </div>
            <template v-for="(item, i) in formDatas.data_anggota" :keys="i">
              <div class="border px-1 border-1 py-1 px-0 mx-0 mb-1 rounded">
                <div class="row mb-1">
                  <div class="col-12">
                    <div>
                      <h5 class="font-weight-bold text-uppercase">Anggota {{ i + 1 }}</h5>
                    </div>
                  </div>
                </div>
                <div class="row mb-1">
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NRK</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nrk || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NAMA</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nama || '-' }}</span>
                    </div>
                  </div>
                  <div class="col-12 col-md-4 col-lg-4">
                    <div>
                      <span class="font-weight-bold text-dark">NIP</span>
                    </div>
                    <div class="">
                      <span class="text-dark">{{ item.nip || '-' }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </b-overlay>
    </template>
    <template v-else>
      <div class="card">
        <div class="card-header d-block border-bottom">
          <div class="text-center">
            <h4 class="font-weight-bolder text-uppercase text-primary">BERITA ACARA HASIL INVENTARISASI PERALATAN DAN
              MESIN
              <br /> Tahun {{ parentFilter.tahun }}
            </h4>
          </div>
        </div>
        <div class="misc-wrapper">
          <div class="misc-inner p-2 p-sm-3">
            <div class="w-100 text-center">
              <b-alert show variant="primary" class="m-0 mb-2">
                <div class="alert-body p-3">
                  <div class="d-flex flex-row justify-content-center" style="gap: 5px;">
                    <div class="icon-wrapper">
                      <feather-icon :icon="'InfoIcon'" class="mr-50" />
                    </div>
                    <div>
                      <span class="font-weight-bold">
                        Silahkan pilih PD/UKPD/UPB untuk melihat berita acara hasil inventarisasi peralatan dan mesin.
                      </span>
                    </div>
                  </div>
                </div>
              </b-alert>
              <b-img fluid :src="imgUrl" alt="Coming soon page" />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
  
<script>
import { ref, nextTick } from '@vue/composition-api'
import Ripple from 'vue-ripple-directive'
import beritaAcaraHasilInventarisasi from "@/composables/b/beritaAcaraHasilInventarisasi";
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import { showNotifikasi } from '@/libs/helper';
import { parserValue } from '@/libs/helper'
import { BFormFile, BModal, VBModal } from 'bootstrap-vue'
import { id as localeId } from "vee-validate/dist/locale/id";
import { closeSistemKibB } from '@/libs/helper';

export default {
  props: {
    fd: { type: Object, required: true },
    parentFilter: { type: Object, required: true }
  },
  setup(props, context) {

    //global variable
    const g = context.root;
    const $route = g.$route;
    const formDatas = ref({});
    const isLoadDetail = ref(false);
    const isFinal = ref(false);
    const getData = () => {
      isLoadDetail.value = true;
      let params = props.parentFilter;
      if ((params.tahun && params.kolok)) {
        beritaAcaraHasilInventarisasi.getDetail(g, params).then(res => {
          formDatas.value = { ...formDatas.value, ...res.data }
          isFinal.value = Boolean(Number(res.is_final));
          generateFormDatas();
          isLoadDetail.value = false;
        }).catch(err => {
          isLoadDetail.value = false;
          console.log(err)
        });
      }
    };
    getData();

    const generateFormDatas = () => {
      let tempDataStruktural = [];
      let tempDataAnggota = [
        { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'anggota', nrk: null, nama: null, nip: null },
      ];
      /* Nanti props.fd.tipe_kolok diganti menjadi data.tipe_kolok */
      if (formDatas.value.tipe_kolok == 'skpd') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'wakil', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? (formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'ketua')) : null;
        const itemWakilKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'wakil') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'sekretaris') : null;
        const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'sekretariat') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemWakilKetua) tempDataStruktural[1] = itemWakilKetua;
        if (itemSekretaris) tempDataStruktural[2] = itemSekretaris;
        if (itemSekretariat) tempDataStruktural[3] = itemSekretariat;
      } else if (formDatas.value.tipe_kolok == 'ukpd') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'sekretariat', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'ketua') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'sekretaris') : null;
        const itemSekretariat = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'sekretariat') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
        if (itemSekretariat) tempDataStruktural[2] = itemSekretariat;
      } else if (formDatas.value.tipe_kolok == 'upb') {
        tempDataStruktural = [
          { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'ketua', nrk: null, nama: null, nip: null },
          { kolok: formDatas.value.kolok, ref_jabatan_ba_tim_kode: 'sekretaris', nrk: null, nama: null, nip: null },
        ];
        const itemKetua = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'ketua') : null;
        const itemSekretaris = (formDatas.value.data_struktural) ? formDatas.value.data_struktural.find(item => item.ref_jabatan_ba_tim_kode === 'sekretaris') : null;
        if (itemKetua) tempDataStruktural[0] = itemKetua;
        if (itemSekretaris) tempDataStruktural[1] = itemSekretaris;
      }
      /* jika data anggota ga kosong */
      if (formDatas.value.data_anggota && formDatas.value.data_anggota.length > 0) tempDataAnggota = formDatas.value.data_anggota;
      formDatas.value.data_struktural = tempDataStruktural;
      formDatas.value.data_anggota = tempDataAnggota;
    }
    /* On Mounted */
    /* ------------------------------- */

    const loadingCetakBeritaAcara = ref(false);
    const cetakDokumenBeritaAcara = () => {

      // const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/ba-tim/cetak?kolok=' + props.parentFilter.kolok; // Replace with your specific link
      const linkToOpen = process.env.VUE_APP_URL_BACKEND + process.env.VUE_APP_SUBFOLDER_API2 + 'sensus-pengguna-b/report/bahi?kolok=' + props.parentFilter.kolok; // Replace with your specific link
      window.open(linkToOpen, '_blank');
    }

    const downloadFileSkTim = (url) => {
      window.open(url, '_blank');
    }

    const closeSistemInformation = ref({});
    setInterval(() => {
      closeSistemInformation.value = closeSistemKibB();
    }, 1000);

    return {
      isLoadDetail,
      getData,
      formDatas,

      loadingCetakBeritaAcara,
      cetakDokumenBeritaAcara,
      downloadFileSkTim,
      parserValue,
      closeSistemInformation,
      isFinal
    };
  },
  computed: {
    headerSkTim() {
      if (this.formDatas.tipe_kolok == 'skpd') {
        return "Pengguna Barang";
      } else if (this.formDatas.tipe_kolok == 'ukpd') {
        return "Kuasa Pengguna Barang";
      } else if (this.formDatas.tipe_kolok == 'upb') {
        return "Sekolah";
      } else {
        return this.formDatas.tipe_kolok;
      }
    },
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormFile,
    BModal,
  },
  watch: {
    parentFilter: {
      handler(newVal, oldVal) {
        this.getData();
      },
      deep: true
    },
  },
  methods: {
    changeStateEvent(event) {
      this.$emit('changeStateEvent', event);
    },
    badgeActionWf(action) {
      if (action == 'setuju') {
        return 'badge-light-success';
      } else {
        return 'badge-light-danger';
      }
    },
    lebelField(field) {
      if (field == 'ketua') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Kepala PD";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Kepala UKPD";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Kepala UPB";
        }
      } else if (field == 'sekretaris') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Pejabat Eselon IV";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Pejabat Eselon IV";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Kepala Tata Usaha";
        }
      } else if (field == 'sekretariat') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Pengurus Barang";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Pengurus Barang Pembantu";
        }
      } else if (field == 'anggota') {
        if (this.formDatas.tipe_kolok == 'skpd') {
          return "Unsur Pada Bidang PD";
        } else if (this.formDatas.tipe_kolok == 'ukpd') {
          return "Unsur Pada Bidang UKPD";
        } else if (this.formDatas.tipe_kolok == 'upb') {
          return "Pengurus Barang/Unsur Pelaksana UPB";
        }
      }
    },
    //
    updateCountdown() {
      const moment = require('moment')
      moment.locale('id');
      const targetDate = moment('2024-03-31 23:59:00');
      const duration = moment.duration(targetDate.diff(moment()));
      const days = Math.floor(duration.asDays());
      const hours = duration.hours();
      const minutes = duration.minutes();
      const seconds = duration.seconds();
      const countdown = `${days} Hari, ${hours} Jam, ${minutes} Menit, ${seconds} Detik`;
      let showCountdown = true;
      this.countdown = countdown;
      this.targetDate = targetDate.format('dddd, DD MMMM YYYY HH:mm:ss');
      this.days = days;
      this.hours = hours;
      this.minutes = minutes;
      this.seconds = seconds;
      if (!targetDate.isAfter()) {
        this.stopCountdown();
        this.showCountdown = false
        this.canUpload = false
      }
    },
    stopCountdown() {
      clearInterval(this.intervalId);
      this.countdown = null;
    },

  },
  mounted() {
    this.updateCountdown();
    this.intervalId = setInterval(this.updateCountdown, 1000);
  },
  data() {
    return {
      imgUrl: require('@/assets/images/pages/coming-soon-dark.svg'),
      required,
      showCountdown: true,
      canUpload: true,
      targetDate: null,
      days: null,
      hours: null,
      minutes: null,
      seconds: null,
      countdown: null,
      intervalId: null,

    };
  },
  directives: {
    'b-modal': VBModal,
    Ripple,
  },
}
</script>
  